import React from 'react';
import Tooltip from 'components/core/Tooltip';
import { useIntl } from 'react-intl';
import { cpmParkingDataShape } from 'constants/PropTypesShapes';
import _get from 'lodash';
import { ReactComponent as WarningIcon } from '../../icons/warning.svg';
import styles from './style.cssmodule.css';

function WarningOccupancy({ parking }) {
  const { formatMessage: t } = useIntl();
  const spacesQuantity = _get(parking, 'spacesQuantity');
  const insideQuantity = _get(parking, 'state.insideQuantity');
  const outsideQuantity = _get(parking, 'state.outsideQuantity');
  const unknownQuantity = _get(parking, 'state.unknownQuantity');

  const showWarning = insideQuantity > spacesQuantity;
  if (!showWarning) return null;
  return (
    <Tooltip
      content={(
        <div>
          <div>{t({ id: 'parking.occupancy.numberOfVehicles' }, { count: spacesQuantity })}</div>
          <div>{t({ id: 'parking.occupancy.vehiclesInside' }, { count: insideQuantity })}</div>
          <div>{t({ id: 'parking.occupancy.vehiclesOutside' }, { count: outsideQuantity })}</div>
          <div>{t({ id: 'parking.occupancy.vehiclesUnknownState' }, { count: unknownQuantity })}</div>
        </div>
      )}
      className={styles.warningContainer}
    >
      <WarningIcon />
    </Tooltip>
  );
}

WarningOccupancy.propTypes = {
  parking: cpmParkingDataShape,
};

WarningOccupancy.defaultProps = {
  parking: null,
};

export default WarningOccupancy;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/WarningOccupancy/WarningOccupancy.jsx